import { render, staticRenderFns } from "./Memberpoint.vue?vue&type=template&id=e084346e&"
import script from "./Memberpoint.vue?vue&type=script&lang=js&"
export * from "./Memberpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports